export default "__VITE_ASSET__BergYWqG__ 100w, __VITE_ASSET__D7TR1uQ0__ 200w, __VITE_ASSET__DD4RQXIf__ 300w";